import WidgetStepPreview from '@components/Widgets/_global/WidgetStepPreview/WidgetStepPreview.vue'

export default {
  name: 'WidgetGallery',
  props: {
    widgetArr: {
      type: Array,
      required: true,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
    enableClone: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WidgetStepPreview,
  },
  data() {
    return {
      btnLoading: false,
    }
  },
  filters: {
    snakeToTitleCase(value) {
      return value ? value.split('-').map(
        item => item.charAt(0).toUpperCase() + item.slice(1),
      ).join(' ') : ''
    },
  },
  methods: {
    triggerChooseWidget(id) {
      this.$emit('choose-widget', id)
    },
    triggerPreviewWidget(id) {
      if (this.btnLoading) {
        return
      }
      this.btnLoading = true
      this.$emit('preview-widget', id)
      this.btnLoading = false
    },
    triggerCloneWidget() {
      if (this.btnLoading) {
        return
      }
      this.btnLoading = true
      this.$emit('clone-widget')
      this.btnLoading = false
    },
  },
}
